<wep-button  (click)="onClick($event)"
             *ngIf="params.valueFormatted && params.valueFormatted.length > 0">
    {{params?.valueFormatted}}
</wep-button>
